<div class="fab-container">
  <button mat-fab class="fab-toggler" (click)="fabVisible = !fabVisible" color="{{color}}">
    @if (!fabVisible) {
      <mat-icon>keyboard_arrow_up</mat-icon>
    }
    @if (fabVisible) {
      <mat-icon>keyboard_arrow_down</mat-icon>
    }
  </button>
  @if (fabVisible) {
    <div class="fab-buttons">
      <ng-content></ng-content>
    </div>
  }
</div>
